import React from 'react';
import './DynamicTableButtons.component.css';

export default class DynamicTableButtons extends React.Component {

    constructor(props) {
        super(props);

        this.isSubmitDisabled = this.isSubmitDisabled.bind(this);
    }

    isSubmitDisabled() {
        if (this.props.isSubmitting) {
            return true;
        }

        let disableSubmit = this.props.orderList.some((e) => e.preloadEquipmentError);
        disableSubmit = disableSubmit || this.props.orderList.every((e) => !e.confirmed);

        return disableSubmit;
    }

    render() {
        return (
            <div>
                <div>
                    <input type="button" 
                        value="Submit" 
                        className="submit-button"
                        disabled={ this.isSubmitDisabled() }
                        onClick={ this.props.onSubmit }/>

                    <input type="button" 
                        value="Clear" 
                        className="clear-button"
                        onClick={ this.props.onClear }
                        disabled={ this.props.isSubmitting } />
                </div>
                <div>
                    <div className={`lds-dual-ring ${ this.props.isSubmitting ? '': 'hidden'}`}></div>
                </div>
            </div>
        )
    }
}
